export class Colors {
  static readonly warning = 'warning';
  static readonly alert = 'alert';
  static readonly success = 'success';
  static readonly insito = 'insito';
  static readonly info = 'info';
  static readonly violet = 'violet';
  static readonly finact = 'finact';
}
